// extracted by mini-css-extract-plugin
export default {"background":"CreateForm_background__BJZ2J","header":"CreateForm_header__evRaW"};